const SelectSemester = ({
    selectedYear,
    selectedSemester,
    setSelectedSemester,
}) => {
    const handleChange = (e) => {
        setSelectedSemester(e.target.value);
    };

    const getSemestersForYear = (year) => {
        if (year === "2026") {
            return ["1"];
        }
        return ["1", "2"];
    };

    return (
        <div className="col-12 col-md-2">
            <h3 className="titles-form font-mpb">Periodo:</h3>
            <div className="caja">
                <select
                    name="semester"
                    id="semester"
                    className="form-select"
                    value={selectedSemester}
                    onChange={handleChange}
                >
                    {getSemestersForYear(selectedYear).map((sem) => (
                        <option key={sem} value={sem}>
                            {sem}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default SelectSemester;
